export default {
  INIT: "BRIDGE.INIT",
  READY: "BRIDGE.READY",
  SEND: "BRIDGE.SEND",
};
